import React from "react";
import styled from "styled-components";

import UILabel from "components/UI/Label";
import UIDropdown from "components/UI/Dropdown";
import DateDropdown from "../DateDropdown";

const Container = styled.div.attrs({ className: "db-controls" })`
  .control {
    display: inline-block;
  }
  .control label {
    color: ${props => props.theme.colors.makoLight};
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
`;

const stateOptions = [{ value: "Texas", text: "Texas" }];
const locationOptions = [{ value: "Westlake", text: "Westlake" }];
const feeTypesOptions = [{ value: "All", text: "All" }];

const AnalyticsDashboardControls = () => {
  return (
    <Container>
      <div className="controls">
        <div className="control mr">
          <UILabel>State</UILabel>
          <UIDropdown
            initialSelectedItem={stateOptions[0]}
            className="inline"
            options={stateOptions}
          />
        </div>
        <div className="control mr">
          <UILabel>Location</UILabel>
          <UIDropdown
            initialSelectedItem={locationOptions[0]}
            className="inline"
            options={locationOptions}
          />
        </div>
        <div className="control mr">
          <UILabel>Fee Types</UILabel>
          <UIDropdown
            initialSelectedItem={feeTypesOptions[0]}
            className="inline"
            options={feeTypesOptions}
          />
        </div>
        <div className="control">
          <UILabel>Date Range</UILabel>
          <DateDropdown side="left" className="inline" />
        </div>
      </div>
    </Container>
  );
};

export default AnalyticsDashboardControls;
